import Grid from '@mui/material/Grid2';
import { useFieldDefaults } from './defaults';
import { RenderField } from './FormField';
import { resolveField, valueAt } from './resolve';
import type { FieldDef, FieldValues } from './types';
import type { FieldForm } from './useFieldForm';

type Source =
  | { form: FieldForm; values?: never; onChange?: never; errors?: never }
  | { form?: never; values: FieldValues; onChange: (name: string, value: unknown) => void; errors?: Record<string, string> };

export type FormFieldsProps = Source & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fields: FieldDef<any>[];
  spacing?: number;
};

/** A whole form from definitions, laid out on the grid each field asks for. */
export function FormFields({ fields, spacing = 2, ...source }: FormFieldsProps) {
  const defaults = useFieldDefaults();
  const values = source.form ? source.form.values : source.values;
  const errors = (source.form ? source.form.errors : source.errors) ?? {};
  const change = source.form ? source.form.setValue : source.onChange;
  return (
    <Grid container spacing={spacing}>
      {fields.map((def) => {
        const field = resolveField(def, defaults, values);
        if (field.hidden) return null;
        return (
          <Grid key={def.name} size={field.grid}>
            <RenderField field={field} value={valueAt(values, def.name)} values={values}
                         onChange={(v) => change(def.name, v)} error={errors[def.name]} />
          </Grid>
        );
      })}
    </Grid>
  );
}
